module.exports = __webpack_public_path__ + "img/searching-dark.7e03aa37.svg";